Ext.define('SA.data.RadiusTableView', {
    alias: 'view.radiusTable',
    extend: 'SA.data.ReportView',

    mixins: {
        locations: 'SA.data.mixin.OneLocation'
    },

    statics: {
        create({project, country, censusRelease, name, locationItems, attributes}) {
            var metersPerUnit = country.getMetersPerRadiusUnit(),
                locationItems = locationItems.filter(item => this.supportsLocation(item)),
                data = {
                    type: 'radiusTable',
                    attributes: attributes.filter(id => this.supportsAttribute(id)),
                    buildingBlocksCensusRelease: censusRelease,
                    filterVisibility: 'strikeout',
                    locationItems: Ext.Array.from(locationItems[0]),
                    name,
                    radii: [metersPerUnit, metersPerUnit * 3, metersPerUnit * 5]
                };

            return new SA.data.RadiusTableView({project, data});
        },

        supportsAttribute(attribute) {
            return SA.data.AttributesCache.isPolygonAttribute(attribute);
        },

        supportsLocation(location) {
            var series = SA.data.LocationsCache.get(SA.data.LocationsCache.toLocationSeries(location));

            if (series.type === 'combination') {
                return false;
            }
            else if (series.type === 'radius') {
                series = SA.data.LocationsCache.get(series.locationSeries);
            }

            return SA.data.GeographicUnits.get(series.geographicUnit).maximumRadius > 0;
        }
    },

    createController() {
        return new SA.RingStudyController(this);
    },

    createDataMap() {
        return new SA.data.DataMap({
            country: this.getCountry()
        });
    },

    getExportQuery() {
        var attributes = this.getAttributes(),
            baseColumns = ['name'],
            country = this.getCountry(),
            isUsa = country === 'USA',
            locations = this.getQueryLocations(),
            query = this.getDataMap().createQueryConfig(SA.Exports.getColumnExpressions({attributes, baseColumns}), locations),
            pluck = Ext.Array.pluck;

        this.getRadii().forEach((radius, index) => {
            query.aggregates[index].overrides.name = isUsa ?
                (Math.round(radius / 1609.344) + ' mile radius') :
                (Math.round(radius / 1000) + ' km radius');
        });

        query.sort = [['desc', 'locationSeries'].concat(pluck(locations, 'id'))];

        return query;
    },

    getReportData(cfg) {
        cfg = cfg || {};

        var map = this.getDataMap();

        map.ensure({
            attributes: this.getAttributes(),
            locations: this.getQueryLocations(),

            fn: cfg.fn,
            scope: cfg.scope
        });

        return map.getData();
    },

    getQueryLocations() {
        var locations = this.getRadiusLocations(),
            countrySeries = SA.Institution.getCountry(this.getCountry()).getLocationSeries();

        locations.push(SA.data.LocationsCache.normalizeLocation(countrySeries));

        return locations;
    },

    getRadii() {
        return this.data.radii;
    },

    getRadiusLocations() {
        var location = this.getLocation(),
            radii = this.getRadii();

        if (!location) {
            return [];
        }

        return radii.map(radius => {
            return SA.data.LocationsCache.normalizeLocation({
                id: location + '-' + radius,
                locationSeries: location,
                radius,
                type: 'radius'
            });
        });
    },

    getSupportedLocationGeoUnitIds() {
        return this.callParent().filter(id => {
            const unit = SA.data.GeographicUnits.get(id);
            return unit.maximumRadius > 0;
        });
    },

    setLocationImpl(location) {
        var data = this.data,
            oldLocations = this.getRadiusLocations();

        if (location) {
            this.project.addLocation(location);

            if (!this.supportsLocation(location)) {
                return false;
            }

            data.locationItems = [location];
        }
        else {
            data.locationItems = [];
        }

        oldLocations.forEach(old => {
            this.getDataMap().removeLocation(old);
        });
    },

    supportsLocation(location) {
        return this.callParent([location]) && this.self.supportsLocation(location);
    }
});